"use client"

import { create } from "zustand"
import { useEffect } from "react"
import { SpellingLocale } from "@/src/constants/spelling-variants"

type SpellingPreference = SpellingLocale | "auto"

interface SpellingState {
  locale: SpellingPreference
  resolvedLocale: SpellingLocale
  setLocale: (locale: SpellingPreference) => void
}

const STORAGE_KEY = "ui-spelling-locale"

const AU_REGIONS = ["AU", "GB", "NZ", "ZA", "IE", "IN"]

function detectRegion(): SpellingLocale {
  if (typeof window === "undefined") return "us"
  const languages = navigator.languages || [navigator.language]
  for (const lang of languages) {
    const parts = lang.split("-")
    if (parts.length >= 2 && AU_REGIONS.includes(parts[1].toUpperCase())) {
      return "au"
    }
  }
  return "us"
}

export const useSpellingStore = create<SpellingState>((set) => ({
  locale: "auto",
  resolvedLocale: "us",
  setLocale: (locale: SpellingPreference) => {
    if (typeof window !== "undefined") {
      localStorage.setItem(STORAGE_KEY, locale)
    }
    const resolvedLocale = locale === "auto" ? detectRegion() : locale
    set({ locale, resolvedLocale })
  },
}))

export function SpellingSyncer() {
  const setLocale = useSpellingStore((state) => state.setLocale)

  useEffect(() => {
    if (typeof window !== "undefined") {
      const stored = localStorage.getItem(STORAGE_KEY) as SpellingPreference | null
      setLocale(stored || "auto")
    }
  }, [setLocale])

  return null
}
